import React, {useCallback, useEffect, useMemo, useState} from "react";
import {useSelector, useDispatch} from "react-redux";
import useDocumentTitle from "../hooks/useDocumentTitle";
import {resetMenu} from "../redux/slices/menuSlice";
import PageHeader from "../components/main/PageHeader";
import UserApi from "../api/UserApi";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faKey, faUser, faBriefcase, faCartShopping, faEye } from '@fortawesome/free-solid-svg-icons'
import {useParams, useNavigate} from "react-router-dom";
import EntityApi from "../api/EntityApi";
import useAuth from "../hooks/useAuth";
import AccessUser from "../components/user/AccessUser";
import AccessUserForm from "../components/user/AccessUserForm";
import OrdersUser from "../components/user/OrdersUser";
import {message, Select } from "antd";
import AvatarUser from "../components/user/AvatarUser";
import {  DeleteOutlined } from '@ant-design/icons';
import axios from "axios";
import ApplicationManagementApi from "../api/ApplicationManagementApi";

const ProfilePage = () => {

    useDocumentTitle('Мой профиль')
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { user, setUser, roles, isAdminOrManagerOrPartner, isAdmin }  = useAuth();
    const { id } = useParams();
    const [isLoading, setIsLoading] = React.useState(false);
    const [isSaved, setIsSaved] = React.useState(false);
    const [isError, setIsError] = React.useState(false);
    const [error, setError] = React.useState('');
    const [inputNameValue, setInputNameValue] = React.useState('');
    const [inputSurnameValue, setInputSurnameValue] = React.useState('');
    const [inputFatherNameValue, setInputFatherNameValue] = React.useState('');
    const [inputCompanyValue, setInputCompanyValue] = React.useState('');
    const [inputCompanyInnValue, setInputCompanyInnValue] = React.useState('');
    const [inputLoginValue, setInputLoginValue] = React.useState('');
    const [inputEmailValue, setInputEmailValue] = React.useState('');
    const [inputPasswordValue, setInputPasswordValue] = React.useState('');
    const [inputConfirmPasswordValue, setInputConfirmPasswordValue] = React.useState('');
    const [inputRoles, setInputRoles] = React.useState([]);
    const [inputCompanyId, setInputCompanyId] = React.useState(null);
    const [userTitle, setUserTitle] = React.useState('');
    const [userId, setUserId] = React.useState(0);
    const [tab, setTab] = React.useState('main');
    const [isReload, setIsReload] = React.useState(false);
    const [accessSelect, setAccessSelect] = React.useState(null);
    const [isSaveForm, setIsSaveForm] = React.useState(false);
    const [avatarUrl, setAvatarUrl] = React.useState(null);
    const [companies, setCompanies] = useState([]);

    // roles
    const [inputRoleAdminChecked, setInputRoleAdminChecked] = React.useState(false);
    const [inputRoleManagerChecked, setInputRoleManagerChecked] = React.useState(false);
    const [inputRolePartnerChecked, setInputRolePartnerChecked] = React.useState(false);
    const [inputRoleCuratorChecked, setInputRoleCuratorChecked] = React.useState(false);
    const [inputBlocked, setInputBlocked] = React.useState(false);

    React.useEffect(() => {
        dispatch(resetMenu());

        if (!isLoading) {
            console.log(id);
            if (id == undefined) {
                UserApi.current().then((data) => {
                    if (data.status === 'success') {

                        if (data.content.item.organizationId) {
                            /*setCompanies([
                                {id: data.content.item.organizationId, name: data.content.item.organizationName}
                            ]);*/
                            setInputCompanyId(data.content.item.organizationId ?? null);
                        }

                        setUserId(data.content.item.id);
                        setInputBlocked(data.content.item.blocked);
                        setInputNameValue(data.content.item.name ?? '');
                        setInputSurnameValue(data.content.item.surname ?? '');
                        setInputFatherNameValue(data.content.item.fatherName ?? '');
                        setInputCompanyValue(data.content.item.company ?? '');
                        setInputCompanyInnValue(data.content.item.company_inn ?? '');
                        setInputCompanyId(data.content.item.organizationId ?? null);
                        setInputLoginValue(data.content.item.login ?? '');
                        setInputEmailValue(data.content.item.email ?? '');
                        setInputRoles(data.content.item.roles ?? []);
                        setAvatarUrl(data.content.item.avatar.url ?? null);
                        setUserTitle(data.content.item.login);
                        if (data.content.item.name) {
                            setUserTitle(
                                (data.content.item.surname ? data.content.item.surname + ' ' : '') +
                                data.content.item.name +
                                (data.content.item.fatherName ? ' ' + data.content.item.fatherName : '')
                            );
                        }
                        setIsLoading(true);
                    }
                });
            } else {
                EntityApi.get('private/user', parseInt(id)).then((data) => {
                    if (data.status === 'success') {

                        if (data.content.item.organizationId) {
                            /*setCompanies([
                                {id: data.content.item.organizationId, name: data.content.item.organizationName}
                            ]);*/
                            setInputCompanyId(data.content.item.organizationId ?? null);
                        }

                        setUserId(data.content.item.id);
                        setInputBlocked(data.content.item.blocked);
                        setInputNameValue(data.content.item.name ?? '');
                        setInputSurnameValue(data.content.item.surname ?? '');
                        setInputFatherNameValue(data.content.item.fatherName ?? '');
                        setInputCompanyValue(data.content.item.company ?? '');
                        setInputCompanyInnValue(data.content.item.company_inn ?? '');
                        setInputLoginValue(data.content.item.login ?? '');
                        setInputEmailValue(data.content.item.email ?? '');
                        setInputRoles(data.content.item.roles ?? []);
                        setAvatarUrl(data.content.item.avatar.url ?? null);
                        setUserTitle(data.content.item.login);
                        if (data.content.item.name) {
                            setUserTitle(
                                (data.content.item.surname ? data.content.item.surname + ' ' : '') +
                                data.content.item.name +
                                (data.content.item.fatherName ? ' ' + data.content.item.fatherName : '')
                            );
                        }
                        setIsLoading(true);
                    }
                }).catch(() => {
                    navigate('/cabinet/users');
                });
            }
        }

        fetchCompanies("");

    }, [])

    const save = () => {

        const params = {
            id: userId,
            fields: {
                login: inputLoginValue,
                blocked: inputBlocked,
                name: inputNameValue,
                surname: inputSurnameValue,
                fatherName: inputFatherNameValue,
                company: inputCompanyValue,
                companyInn: inputCompanyInnValue,
                email: inputEmailValue,
                password: inputPasswordValue,
                confirmPassword: inputConfirmPasswordValue,
                roles: inputRoles,
                organizationId: inputCompanyId
            }
        }

        UserApi.post(params).then((data) => {
            setIsError(false);
            setIsSaved(false);
            if (data.status === 'success') {
                setIsSaved(true);
                if (inputNameValue) {
                    setUserTitle(
                        (inputSurnameValue ? inputSurnameValue + ' ' : '') +
                        inputNameValue +
                        (inputFatherNameValue ? ' ' + inputSurnameValue : ''));
                } else {
                    setUserTitle(inputLoginValue);
                }

                if (user.id === userId) {
                    let currentUser = {
                        id: user.id,
                        login: user.login,
                        name: inputNameValue
                    }
                    localStorage.setItem('user', JSON.stringify(currentUser));
                    setUser(currentUser);
                }

            } else {
                data.error.messages.forEach((mes) => {
                    setError(mes);
                    message.error(mes);
                })
                setIsError(true);
            }
            setInputPasswordValue('');
            setInputConfirmPasswordValue('');
        });

    }

    /*React.useEffect(() => {

        let editRoles = inputRoles;

        if (inputRoleAdminChecked) {
            if (editRoles.indexOf('ROLE_ADMIN') !== -1) {
                editRoles.splice(inputRoles.indexOf('ROLE_ADMIN'), 1);
            } else {
                editRoles.push('ROLE_ADMIN');
            }
        }

        setInputRoles(editRoles);

        console.log(inputRoleAdminChecked);
        console.log(inputRoles);
        //save();

    }, [inputRoleAdminChecked]);*/

    React.useEffect(() => {
        setInputRoleAdminChecked(inputRoles.includes('ROLE_ADMIN'));
        setInputRoleManagerChecked(inputRoles.includes('ROLE_MANAGER'));
        setInputRolePartnerChecked(inputRoles.includes('ROLE_PARTNER'));
        setInputRoleCuratorChecked(inputRoles.includes('ROLE_CURATOR'));
    }, [inputRoles])

    React.useEffect(() => {
        if (isSaveForm) {
            save();
            setIsSaveForm(false);
        }
    }, [isSaveForm]);

    const onChangeRole = (role, isChecked, isSave = true) => {

        if (user.id === userId) {
            message.error('Вы не можете менять роли у себя');
            return;
        }

        if (role === 'ROLE_ADMIN') {
            if (isChecked) {
                setInputRoles(['ROLE_USER', role]);
                setInputRoleManagerChecked(false);
                setInputRolePartnerChecked(false);
                setInputRoleCuratorChecked(false);
            } else {
                setInputRoles(['ROLE_USER']);
            }
        }

        if (role === 'ROLE_MANAGER') {
            if (isChecked) {
                setInputRoles(['ROLE_USER', role]);
                setInputRoleAdminChecked(false);
                setInputRolePartnerChecked(false);
                setInputRoleCuratorChecked(false);
            } else {
                setInputRoles(['ROLE_USER']);
            }
        }

        if (role === 'ROLE_PARTNER') {
            if (isChecked) {
                setInputRoles(['ROLE_USER', role]);
                setInputRoleAdminChecked(false);
                setInputRoleManagerChecked(false);
                setInputRoleCuratorChecked(false);
            } else {
                setInputRoles(['ROLE_USER']);
            }
        }

        if (role === 'ROLE_CURATOR') {
            if (isChecked) {
                setInputRoles(['ROLE_USER', role]);
                setInputRoleAdminChecked(false);
                setInputRolePartnerChecked(false);
                setInputRoleManagerChecked(false);
            } else {
                setInputRoles(['ROLE_USER']);
            }
        }

        if (isSave) {
            setIsSaveForm(!isSaveForm);
        }

/*
        if (id === undefined) {

            alert('Вы не можете удалить у себя права администратора');

        } else if (role === 'ROLE_MANAGER') {

            setInputRoleManagerChecked(!inputRoleManagerChecked);

            let editRoles = inputRoles;
            if (inputRoleManagerChecked && editRoles.indexOf('ROLE_MANAGER') !== -1) {
                editRoles.splice(inputRoles.indexOf('ROLE_MANAGER'), 1);
            } else {
                editRoles.push('ROLE_MANAGER');
            }

            setInputRoles(editRoles);
            save();

        } else {

            setInputRoleAdminChecked(!inputRoleAdminChecked);

            // add roles
            let editRoles = inputRoles;
            if (inputRoleAdminChecked && editRoles.indexOf('ROLE_ADMIN') !== -1) {
                editRoles.splice(inputRoles.indexOf('ROLE_ADMIN'), 1);
            } else {
                editRoles.push('ROLE_ADMIN');
            }

            setInputRoles(editRoles);
            save();

        }*/

    }

    const onChangePartner = (isPartner) => {
        if (isPartner) {
            setInputRolePartnerChecked(true);
            let editRoles = inputRoles;
            if (editRoles.indexOf('ROLE_PARTNER') === -1) {
                editRoles.push('ROLE_PARTNER');
            }
            setInputRoles(editRoles);
        } else {
            setInputRolePartnerChecked(false);
            let editRoles = inputRoles;
            if (editRoles.indexOf('ROLE_PARTNER') !== -1) {
                editRoles.splice(inputRoles.indexOf('ROLE_PARTNER'), 1);
            }
            setInputRoles(editRoles);
        }
        save();
    }

    const onChangeBlocked = (value) => {
        setInputBlocked(value);
        setIsSaveForm(!isSaveForm);
    }

    const openFormAccess = (item) => {
        setAccessSelect(item);
        console.log('openFormAccess');
        console.log(item);
    }

    const fetchCompanies = useCallback(async (query = "") => {
        try {
            const data = await ApplicationManagementApi.listCompanies(query);
            setCompanies(data || []);
        } catch (e) {
            message.error(e?.message || "Не удалось загрузить компании");
        }
    }, []);

    const optionsCompanies = useMemo(
        () =>
            companies.map((c) => ({
                label: c.name + ' [' + c.inn + ']',
                value: c.id,
            })),
        [companies]
    );

    return (
        <>
            <PageHeader title={"Профиль пользователя"}/>
            <div className="grid grid-cols-12 gap-4 sm:gap-5 lg:gap-6">
            <div className="col-span-12 lg:col-span-4">
                <div className="card p-4 sm:p-5">
                    <div className="flex items-center space-x-4">
                        <div className={'flex items-center'}>
                            <div>
                                {
                                    (roles.includes('ROLE_ADMIN') || user.id === userId) ?
                                    <AvatarUser id={userId} url={avatarUrl} />
                                        :
                                        <img className={'rounded-full'} src={avatarUrl ?? '/images/100x100.png'} />
                                }
                            </div>
                            <div className={'pl-4'}>
                                <h3 className="text-base font-medium text-slate-700 dark:text-navy-100">
                                    {userTitle}
                                </h3>
                                <p className="text-xs+">
                                    {inputRoles.includes('ROLE_ADMIN') && 'Администратор'}
                                    {inputRoles.includes('ROLE_MANAGER') && 'Менеджер'}
                                    {inputRoles.includes('ROLE_PARTNER') && 'Партнер'}
                                    {inputRoles.includes('ROLE_CURATOR') && 'Куратор'}
                                    {
                                        !inputRoles.includes('ROLE_ADMIN') &&
                                        !inputRoles.includes('ROLE_MANAGER') &&
                                        !inputRoles.includes('ROLE_PARTNER') &&
                                        !inputRoles.includes('ROLE_CURATOR')
                                        && 'Клиент'
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    <ul className="mt-6 space-y-1.5 font-inter font-medium">
                        <li>
                            <button
                                className={`flex w-full items-center space-x-2 rounded-lg ${tab == 'main' ? 'bg-primary text-white' : 'bg-slate-150 text-slate-600 dark:bg-navy-500 dark:text-navy-50'} px-4 py-2.5 tracking-wide outline-none transition-all dark:bg-accent`}
                                onClick={() => setTab('main')}>
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none"
                                     viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                                          d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                </svg>
                                <span>Личные данные</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={() => setTab('access-product')} className={`flex w-full items-center space-x-2 rounded-lg ${tab == 'access-product' || tab == 'access-form' ? 'bg-primary text-white' : 'bg-slate-150 text-slate-600 dark:bg-navy-500 dark:text-navy-50'} px-4 py-2.5 tracking-wide outline-none transition-all dark:bg-accent`}>
                                <FontAwesomeIcon icon={faEye} />
                                <span>Доступы у курсам</span>
                            </button>
                        </li>
                        <li>
                            <button onClick={() => setTab('orders')} className={`flex w-full items-center space-x-2 rounded-lg ${tab == 'orders' ? 'bg-primary text-white' : 'bg-slate-150 text-slate-600 dark:bg-navy-500 dark:text-navy-50'} px-4 py-2.5 tracking-wide outline-none transition-all dark:bg-accent`}>
                                <FontAwesomeIcon icon={faCartShopping} />
                                <span>Заказы</span>
                            </button>
                        </li>
                        { roles.includes('ROLE_ADMIN') &&
                        <li>
                            <button className={`flex w-full items-center space-x-2 rounded-lg ${tab == 'access' ? 'bg-primary text-white' : 'bg-slate-150 text-slate-600 dark:bg-navy-500 dark:text-navy-50'} px-4 py-2.5 tracking-wide outline-none transition-all dark:bg-accent`}
                                    onClick={() => setTab('access')}>
                                <svg xmlns="http://www.w3.org/2000/svg"
                                     className="h-5 w-5 text-slate-400"
                                     fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                                    <path strokeLinecap="round" strokeLinejoin="round"
                                          d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path>
                                </svg>
                                <span>Настройки доступа</span>
                            </button>
                        </li>
                        }

                    </ul>
                </div>
            </div>
            <div className="col-span-12 lg:col-span-8">
                <div className={tab === 'main' ? "card" : "hidden"}>
                    <div
                        className="flex flex-col items-center space-y-4 border-b border-slate-200 p-4 dark:border-navy-500 sm:flex-row sm:justify-between sm:space-y-0 sm:px-5">
                        <h2 className="text-lg font-medium tracking-wide text-slate-700 dark:text-navy-100">
                            Личные данные
                        </h2>
                        <div className="flex justify-center space-x-2">
                         {/*   <button
                                className="btn min-w-[7rem] rounded-full border border-slate-300 font-medium text-slate-700 hover:bg-slate-150 focus:bg-slate-150 active:bg-slate-150/80 dark:border-navy-450 dark:text-navy-100 dark:hover:bg-navy-500 dark:focus:bg-navy-500 dark:active:bg-navy-500/90">
                                Cancel
                            </button>*/}
                            {
                                (isAdminOrManagerOrPartner || user.id === userId) &&
                                <button onClick={() => save()}
                                        className="btn min-w-[7rem] mob-hidden rounded-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                                    Сохранить
                                </button>
                            }
                        </div>
                    </div>
                    <div className="p-4 sm:p-5">
                        {
                            isSaved &&
                                <div className="alert flex rounded-lg bg-success/10 px-4 py-4 text-success dark:bg-success/15 sm:px-5">
                                    Данные успешно сохранены
                                </div>
                        }
                        {
                            isError &&
                            <div className="alert flex rounded-lg bg-error/10 px-4 py-4 text-error dark:bg-success/15 sm:px-5">{error}</div>
                        }
                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                            <label className="block">
                                <span>Имя</span>
                                <span className="relative mt-1.5 flex">
                      <input
                          disabled={!isAdminOrManagerOrPartner}
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          placeholder="Введите имя" type="text"
                          onChange={(evt) => setInputNameValue(evt.target.value)}
                          value={inputNameValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faUser} />
                      </span>
                    </span>
                            </label>
                            <label className="block">
                                <span>Фамилия</span>
                                <span className="relative mt-1.5 flex">
                      <input
                          disabled={!isAdminOrManagerOrPartner}
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          placeholder="Введите фамилию" type="text"
                          onChange={(evt) => setInputSurnameValue(evt.target.value)}
                          value={inputSurnameValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faUser} />
                      </span>
                    </span>
                            </label>
                            <label className="block">
                                <span>Отчество</span>
                                <span className="relative mt-1.5 flex">
                      <input
                          disabled={!isAdminOrManagerOrPartner}
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          placeholder="Введите отчество" type="text"
                          onChange={(evt) => setInputFatherNameValue(evt.target.value)}
                          value={inputFatherNameValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faUser} />
                      </span>
                    </span>
                            </label>
                            <label className="block"></label>
                            <label className="block sm:col-span-2">
                                <div className="alert flex rounded-lg bg-info/10 px-4 py-4 text-info dark:bg-info/15 sm:px-5">
                                    При заполнении текстовых полей организации, если данная организация с таким ИНН не существует, то она будет
                                    создана автоматически и пользователь будет привязан к ней. Если будет выбрана привязка к другой компании, то
                                    будет привязан к выбранной компании.
                                </div>
                            </label>
                            <label className="block">
                                <span>Организация</span>
                                <span className="relative mt-1.5 flex">
                      <input
                          disabled={!isAdminOrManagerOrPartner}
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          placeholder="Введите название организации" type="text"
                          onChange={(evt) => setInputCompanyValue(evt.target.value)}
                          value={inputCompanyValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faBriefcase} />
                      </span>
                    </span>
                            </label>
                            <label className="block">
                                <span>ИНН Организации</span>
                                <span className="relative mt-1.5 flex">
                      <input
                          disabled={!isAdminOrManagerOrPartner}
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          placeholder="Введите ИНН организации" type="text"
                          onChange={(evt) => setInputCompanyInnValue(evt.target.value)}
                          value={inputCompanyInnValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faBriefcase} />
                      </span>
                    </span>
                            </label>

                            <label className="block">
                                <span>Привязка к организации</span>
                                <span className="relative mt-1.5 flex">
                     <Select
                         disabled={!isAdminOrManagerOrPartner}
                         showSearch
                         optionFilterProp="label"
                         allowClear={true}
                         className="ant-select-rounded w-full"
                         options={optionsCompanies}
                         placeholder="Введите название для поиска"
                         value={inputCompanyId}
                         onChange={(value) => setInputCompanyId(value)}
                     />
                    </span>
                            </label>

                            <div className="block">
                                <span>Роль в организации</span>
                                <label className="relative mt-1.5 flex items-center space-x-2">
                                    <input
                                        disabled={!isAdminOrManagerOrPartner}
                                        checked={inputRoleCuratorChecked}
                                        onChange={(e) => onChangeRole('ROLE_CURATOR', e.target.checked, false)}
                                        className="form-checkbox is-basic h-5 w-5 rounded-full border-slate-400/70 checked:bg-slate-500 checked:border-slate-500 hover:border-slate-500 focus:border-slate-500 dark:border-navy-400 dark:checked:bg-navy-400"
                                        type="checkbox"
                                    />
                                    <p>Куратор</p>
                                </label>
                            </div>

                            <label className="block">
                                <span>Номер телефона</span>
                                <span className="relative mt-1.5 flex">
                      <input
                          disabled={!isAdmin}
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          placeholder="Введите номер телефона" type="text"
                          onChange={(evt) => setInputLoginValue(evt.target.value)}
                          value={inputLoginValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faPhone} />
                      </span>
                    </span>
                            </label>
                            <label className="block">
                                <span>E-mail</span>
                                <span className="relative mt-1.5 flex">
                      <input
                          disabled={!isAdminOrManagerOrPartner}
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          placeholder="Введите адрес электронной почты" type="text"
                          onChange={(evt) => setInputEmailValue(evt.target.value)}
                          value={inputEmailValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faEnvelope} />
                      </span>
                    </span>
                            </label>
                        </div>
                        <div className="my-7 h-px bg-slate-200 dark:bg-navy-500"></div>
                        {
                            (isAdminOrManagerOrPartner || user.id === userId) &&
                            <div>
                                <h3 className="text-base font-medium text-slate-600 dark:text-navy-100 my-3.5">
                                    Настройки безопасности
                                </h3>
                                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                    <label className="block">
                                        <span>Пароль</span>
                                        <span className="relative mt-1.5 flex">
                      <input
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          type="password" autoComplete="new-password"
                          onChange={(evt) => setInputPasswordValue(evt.target.value)}
                          value={inputPasswordValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faKey}/>
                      </span>
                    </span>
                                    </label>
                                    <label className="block">
                                        <span>Подтвердите пароль</span>
                                        <span className="relative mt-1.5 flex">
                      <input
                          className="form-input peer w-full rounded-full border border-slate-300 bg-transparent px-3 py-2 pl-9 placeholder:text-slate-400/70 hover:border-slate-400 focus:border-primary dark:border-navy-450 dark:hover:border-navy-400 dark:focus:border-accent"
                          type="password" autoComplete="new-password"
                          onChange={(evt) => setInputConfirmPasswordValue(evt.target.value)}
                          value={inputConfirmPasswordValue}
                      />
                      <span
                          className="pointer-events-none absolute flex h-full w-10 items-center justify-center text-slate-400 peer-focus:text-primary dark:text-navy-300 dark:peer-focus:text-accent">
                        <FontAwesomeIcon icon={faKey}/>
                      </span>
                    </span>
                                    </label>
                                </div>
                            </div>
                        }
                        {
                            (isAdminOrManagerOrPartner || user.id === userId) &&
                            <button onClick={() => save()}
                                    className="btn w-full mt-4 desktop-hidden rounded-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                                Сохранить
                            </button>
                        }
                    </div>
                </div>
                <div className={tab === 'access' ? "card" : "hidden"}>
                    <div
                        className="flex flex-col items-center space-y-4 border-b border-slate-200 p-4 dark:border-navy-500 sm:flex-row sm:justify-between sm:space-y-0 sm:px-5">
                        <h2 className="text-lg font-medium tracking-wide text-slate-700 dark:text-navy-100">
                            Настройки доступа
                        </h2>
                    </div>
                    <div className="p-4 sm:p-5">
                        <label className="inline-flex items-center space-x-2">
                            <input
                                checked={inputRoleAdminChecked}
                                onChange={(e) => onChangeRole('ROLE_ADMIN', e.target.checked)}
                                className="form-checkbox is-basic h-5 w-5 rounded-full border-slate-400/70 checked:bg-slate-500 checked:border-slate-500 hover:border-slate-500 focus:border-slate-500 dark:border-navy-400 dark:checked:bg-navy-400"
                                type="checkbox"
                            />
                            <p>Администратор</p>
                        </label>
                        <div>
                            <label className="inline-flex items-center space-x-2">
                                <input
                                    checked={inputRoleManagerChecked}
                                    onChange={(e) => onChangeRole('ROLE_MANAGER', e.target.checked)}
                                    className="form-checkbox is-basic h-5 w-5 rounded-full border-slate-400/70 checked:bg-slate-500 checked:border-slate-500 hover:border-slate-500 focus:border-slate-500 dark:border-navy-400 dark:checked:bg-navy-400"
                                    type="checkbox"
                                />
                                <p>Менеджер</p>
                            </label>
                        </div>
                        <div>
                            <label className="inline-flex items-center space-x-2">
                                <input
                                    checked={inputRolePartnerChecked}
                                    onChange={(e) => onChangeRole('ROLE_PARTNER', e.target.checked)}
                                    className="form-checkbox is-basic h-5 w-5 rounded-full border-slate-400/70 checked:bg-slate-500 checked:border-slate-500 hover:border-slate-500 focus:border-slate-500 dark:border-navy-400 dark:checked:bg-navy-400"
                                    type="checkbox"
                                />
                                <p>Партнер</p>
                            </label>
                        </div>
                        <div>
                            <label className="inline-flex items-center space-x-2">
                            <input
                                checked={inputRoleCuratorChecked}
                                onChange={(e) => onChangeRole('ROLE_CURATOR', e.target.checked, true)}
                                className="form-checkbox is-basic h-5 w-5 rounded-full border-slate-400/70 checked:bg-slate-500 checked:border-slate-500 hover:border-slate-500 focus:border-slate-500 dark:border-navy-400 dark:checked:bg-navy-400"
                                type="checkbox"
                            />
                                <p>Куратор</p>
                            </label>
                        </div>
                        {/*<div>
                            <label className="inline-flex items-center space-x-2">
                                <input
                                    checked={inputRoleCuratorChecked}
                                    onChange={(e) => onChangeRole('ROLE_CURATOR', e.target.checked)}
                                    className="form-checkbox is-basic h-5 w-5 rounded-full border-slate-400/70 checked:bg-slate-500 checked:border-slate-500 hover:border-slate-500 focus:border-slate-500 dark:border-navy-400 dark:checked:bg-navy-400"
                                    type="checkbox"
                                />
                                <p>Куратор</p>
                            </label>
                        </div>*/}
                        <div>
                            <label className="inline-flex items-center space-x-2 mt-4">
                                <input
                                    checked={inputBlocked}
                                    onChange={(event) => onChangeBlocked(event.target.checked)}
                                    className="form-checkbox is-basic h-5 w-5 rounded-full border-slate-400/70 checked:bg-slate-500 checked:border-slate-500 hover:border-slate-500 focus:border-slate-500 dark:border-navy-400 dark:checked:bg-navy-400"
                                    type="checkbox"
                                />
                                <p>Заблокировать</p>
                            </label>
                        </div>
                    </div>
                </div>
                { userId > 0 &&
                <div className={tab === 'access-product' ? "card" : "hidden"}>
                    <AccessUser openForm={() => setTab('access-form')} openFormAccess={(item) => setAccessSelect(item)}
                                reload={isReload} userId={userId}/>
                </div>
                }
                { userId > 0 &&
                <div className={tab === 'access-form' ? "card" : "hidden"}>
                    <AccessUserForm openList={() => setTab('access-product')} preSelect={accessSelect}
                                    onReload={() => setIsReload(!isReload)} userId={userId}/>
                </div>
                }
                { userId > 0 &&
                    <div className={tab === 'orders' ? "card" : "hidden"}>
                    <OrdersUser userId={userId}/>
                    </div>
                }
            </div>
            </div>
        </>
    )

}

export default ProfilePage;
